<div [class]="theme" class="example-container">
	<img class="logo" src="./assets/corecloud.png" />
	<br />
	<h1 class="center mat-headline-5">{{ 'login.headerWelcome.label' | translate }}</h1>
	<p class="center mat-subtitle-2">{{ 'login.userCreated.label' | translate }}</p>
	<p class="center mat-subtitle-2">
		<button mat-raised-button (click)="logout()">
			{{ 'login.userCreated.logout' | translate }}
		</button>
	</p>
</div>
